import { PREFIX } from '../common/constants';

export const FORGET_EMAIL_KEY = 'forget.pwd.email.tab';
export const FORGET_PHONE_KEY = 'forget.pwd.phone.tab';

export const LOCAL_EMAIL_INPUT_KEY = `${PREFIX}_forget_email_input`;
export const LOCAL_PHONE_INPUT_KEY = `${PREFIX}_forget_phone_input`;

export const LOCAL_EMAIL_TIME_KEY = `${PREFIX}_forget_email_time`;
export const LOCAL_PHONE_TIME_KEY = `${PREFIX}_forget_phone_time`;

export const LOCAL_EMAIL_PREV_COUNT_TIME = `${PREFIX}_forget_email_count_time`;
export const LOCAL_PHONE_PREV_COUNT_TIME = `${PREFIX}_forget_phone_count_time`;

export const NAMESPACE = '$entrance_forgetPwd';
